document.addEventListener("DOMContentLoaded", function () {

  const track   = document.getElementById("sliderTrack");
  if (!track) return;

  const section   = track.closest(".gift-section");
  const viewport  = track.parentElement;
  const nextBtn   = section.querySelector(".next");
  const prevBtn   = section.querySelector(".prev");

  const originalCards = Array.from(track.querySelectorAll(".product-card"));
  const total         = originalCards.length;
  if (total === 0) return;

  function getVisible() {
    const w = window.innerWidth;
    if (w <= 600)  return 1;   
    if (w <= 1440) return 2;   
    return 3;                 
  }

  let visibleCount = getVisible();
  let index        = 0;
  let autoTimer    = null;

  function setCardWidth() {
    visibleCount = getVisible();
    const sliderW = viewport.offsetWidth;
    const gap     = 16;
    const cardW   = (sliderW - gap * (visibleCount - 1)) / visibleCount;

    track.querySelectorAll(".product-card").forEach(c => {
      c.style.width    = cardW + "px";
      c.style.minWidth = cardW + "px";
    });

    goTo(0, false);
  }

  function buildClones() {
    track.querySelectorAll(".product-card.clone").forEach(c => c.remove());
    originalCards.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add("clone");
      track.appendChild(clone);
    });
  }

  function cardWidth() {
    const c = track.querySelector(".product-card");
    return c ? c.offsetWidth + 16 : 0;
  }

  function goTo(i, animate = true) {
    index = i;
    track.style.transition = animate ? "transform .5s ease" : "none";
    track.style.transform  = `translateX(-${index * cardWidth()}px)`;
  }

  function slideNext() {
    index++;
    track.style.transition = "transform .5s ease";
    track.style.transform  = `translateX(-${index * cardWidth()}px)`;

    if (index >= total) {
      setTimeout(() => {
        track.style.transition = "none";
        index = 0;
        track.style.transform  = "translateX(0)";
      }, 520);
    }
  }

  function slidePrev() {
    if (index > 0) {
      index--;
      track.style.transition = "transform .5s ease";
      track.style.transform  = `translateX(-${index * cardWidth()}px)`;
    } else {
      track.style.transition = "none";
      index = total - 1;
      track.style.transform  = `translateX(-${index * cardWidth()}px)`;
      setTimeout(() => {
        track.style.transition = "transform .5s ease";
      }, 20);
    }
  }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(slideNext, 3000);
  }

  function stopAuto() {
    if (autoTimer) clearInterval(autoTimer);
  }

  nextBtn.addEventListener("click", () => { stopAuto(); slideNext(); startAuto(); });
  prevBtn.addEventListener("click", () => { stopAuto(); slidePrev(); startAuto(); });

  let touchStartX = 0;
  viewport.addEventListener("touchstart", e => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  viewport.addEventListener("touchend", e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      stopAuto();
      diff > 0 ? slideNext() : slidePrev();
      startAuto();
    }
  }, { passive: true });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      buildClones();
      setCardWidth();
      startAuto();
    }, 200);
  });

  buildClones();
  setCardWidth();
  startAuto();
});